"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
//Estilo do componente PPGrid
var styles_1 = require("@material-ui/core/styles");
exports.useStyles = (0, styles_1.makeStyles)(function (theme) { return (0, styles_1.createStyles)({
    form: {
        padding: 32,
        margin: 0,
        width: '100%',
        backgroundColor: '#E2E6F3',
        borderRadius: 8,
        boxShadow: '0px 0px 18px rgba(58, 79, 135, 0.3)',
    },
    formChildren: {
        padding: theme.spacing(2),
        margin: theme.spacing(1),
        width: 'auto',
        backgroundColor: '#E2E6F3',
        borderRadius: 8,
        boxShadow: '0px 0px 18px rgba(58, 79, 135, 0.3)',
    },
    formDad: {
        padding: theme.spacing(2),
        width: 'auto',
        backgroundColor: '#E2E6F3',
        borderRadius: 8,
        boxShadow: '0px 0px 18px rgba(58, 79, 135, 0.3)',
    },
    default: {
        backgroundColor: 'transparent',
    }
}); });
